import styled from 'styled-components';
import { ActionButtonStyled } from '../styles';

export const DropdownOptionLabelStyled = styled.span`
  text-transform: capitalize;
  font-size: 1.4rem;
  line-height: 2.4rem;
`;

export const FilterStatusStyled = styled.b`
  margin-left: 1rem;
`;

export const FilterDropdownButtonStyled = styled(ActionButtonStyled)`
  min-width: 25.8rem;
`;
